import { KeyboardEvent, useState } from 'react';
import {
  Card,
  Typography,
  CardContent,
  Grid,
  TextField,
  TextFieldProps,
} from '@mui/material';
import { LocationOn } from '@mui/icons-material';

import { useAppSelector, useAppDispatch } from '../../../store/hooks';
import ClientAdressModal from '../../modals/client/ClientAddressModal';

import Colors from '../../../constants/Colors';
import Endereco from '../../../models/address/address.model';
import { CAMPO_OBRIGATORIO } from '../../../util/string/utilStrings';
import { clientFormErrorActions } from '../../../store/error/client-form-error-slice';

interface Props {
  enderecoPrincipalObjeto: Endereco;
  enderecoEntregaObjeto: Endereco;
  enderecoPrincipal: string;
  enderecoEntrega: string;
}

const AddressCard = (props: Props) => {
  const {
    enderecoPrincipalObjeto,
    enderecoEntregaObjeto,
    enderecoPrincipal,
    enderecoEntrega,
  } = props;
  const [enderecoPrincipalCompleto, setEnderecoPrincipalCompleto] =
    useState<string>(enderecoPrincipal);
  const [enderecoParaEntregaCompleto, setEndercoParaEntregaCompleto] =
    useState<string>(enderecoEntrega);
  const [openModalPrincipal, setOpenModalPrincipal] = useState<boolean>(false);
  const [openModalEntrega, setOpenModalEntrega] = useState<boolean>(false);

  const mainAddressError = useAppSelector(
    (state) => state.clientFormError.mainAddressError
  );

  const isReadOnly = useAppSelector(
    (state) => state.readability.isClientReadOnly
  );

  const dispatch = useAppDispatch();

  const handleSetAddress = (address: string): void => {
    if (mainAddressError) {
      dispatch(clientFormErrorActions.mainAddressErrorSetter(false));
    }
    setEndercoParaEntregaCompleto(address);
  };

  const clickableFieldSx = {
    '& .MuiInputBase-root': {
      cursor: 'pointer',
    },
    '& .MuiInputBase-input': {
      cursor: 'pointer',
    },
    '& .MuiInputBase-input::placeholder': {
      color: 'darkgray',
      WebkitTextFillColor: 'darkgray',
      opacity: 1,
    },
  };

  const buildClickableInputProps = (
    openModal: () => void
  ): TextFieldProps['InputProps'] => ({
    readOnly: true,
    onClick: openModal,
    onKeyDown: (ev) => {
      if ((ev as KeyboardEvent<HTMLDivElement>).key === 'Enter' || (ev as KeyboardEvent<HTMLDivElement>).key === ' ') {
        ev.preventDefault();
        openModal();
      }
    },
    role: 'button',
    tabIndex: 0,
  });

  return (
    <>
      <ClientAdressModal
        open={openModalPrincipal}
        toggle={() => setOpenModalPrincipal(!openModalPrincipal)}
        setAddress={(address: string) => setEnderecoPrincipalCompleto(address)}
        addressType={'Principal'}
        endereco={{ ...enderecoPrincipalObjeto }}
      />
      <ClientAdressModal
        open={openModalEntrega}
        toggle={() => setOpenModalEntrega(!openModalEntrega)}
        setAddress={handleSetAddress}
        addressType={'para Entrega'}
        endereco={{ ...enderecoEntregaObjeto }}
      />
      <Card>
        <CardContent>
          <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
              <Typography
                sx={{
                  backgroundColor: Colors.titleRowWithBackgroundColor,
                  pl: 1,
                  pt: 0.75,
                  mt: -1,
                }}
                variant='body2'
                color={Colors.titleWithBackgroudColor}
              >
                <LocationOn fontSize={'inherit'} /> Endereços
              </Typography>
            </Grid>

            <Grid item xs={12} md={6}>
              {isReadOnly ? (
                <TextField
                  variant='outlined'
                  sx={{
                    borderColor: mainAddressError ? Colors.muiDanger : '',
                  }}
                  error={mainAddressError}
                  required
                  multiline={true}
                  fullWidth
                  InputProps={{ readOnly: true }}
                  placeholder='Principal'
                  value={enderecoPrincipalCompleto}
                  type='text'
                  size={'small'}
                  label='Principal'
                  helperText={mainAddressError ? CAMPO_OBRIGATORIO : ''}
                />
              ) : (
                <TextField
                  variant='outlined'
                  error={mainAddressError}
                  required
                  multiline={true}
                  fullWidth
                  InputProps={buildClickableInputProps(() =>
                    setOpenModalPrincipal(true)
                  )}
                  placeholder='Principal'
                  value={enderecoPrincipalCompleto}
                  type='text'
                  size={'small'}
                  label='Principal'
                  helperText={mainAddressError ? CAMPO_OBRIGATORIO : ''}
                  sx={clickableFieldSx}
                />
              )}
            </Grid>
            <Grid item xs={12} md={6}>
              {isReadOnly ? (
                <TextField
                  variant='outlined'
                  multiline={true}
                  InputProps={{ readOnly: true }}
                  fullWidth
                  placeholder='Para entrega'
                  value={enderecoParaEntregaCompleto}
                  type='text'
                  size={'small'}
                  color='success'
                  label='Para entrega'
                />
              ) : (
                <TextField
                  variant='outlined'
                  multiline={true}
                  fullWidth
                  InputProps={buildClickableInputProps(() =>
                    setOpenModalEntrega(true)
                  )}
                  placeholder='Para entrega'
                  value={enderecoParaEntregaCompleto}
                  type='text'
                  size={'small'}
                  color='success'
                  label='Para entrega'
                  sx={clickableFieldSx}
                />
              )}
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
};

export default AddressCard;
